<div *ngIf="isVisible"
     class="absolute top-full left-0 mt-1 w-full max-w-2xl bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg shadow-lg z-50 max-h-[480px] overflow-y-auto">

  <!-- Loading -->
  <div *ngIf="results?.isLoading" class="p-6 text-center text-gray-500 text-sm">
    <div class="animate-spin inline-block w-5 h-5 border-2 border-gray-300 border-t-blue-500 rounded-full"></div>
    <p class="mt-2 m-0">Buscando...</p>
  </div>

  <!-- Sin resultados -->
  <div *ngIf="!results?.isLoading && !hasAnyResults() && searchTerm.length >= 2"
       class="p-6 text-center text-gray-500 dark:text-gray-400 text-sm">
    No se encontraron resultados para "<span class="font-medium">{{ searchTerm }}</span>"
  </div>

  <!-- Resultados -->
  <ng-container *ngIf="!results?.isLoading && hasAnyResults()">

    <!-- NAVEGACIÓN RÁPIDA -->
    <div *ngIf="(results?.navigation?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 p-2">
    <button *ngFor="let r of results?.navigation"
            (click)="onResultClick(r)"
            class="w-full flex items-center gap-3 px-3 py-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors border border-gray-200 dark:border-gray-700">

        <div class="w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center flex-shrink-0">
        <svg class="w-5 h-5 text-blue-600 dark:text-blue-400" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
        </div>

        <div class="flex-1 min-w-0">
        <p class="text-base font-medium text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
        <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>

        <span class="text-xs text-gray-400 dark:text-gray-500 flex-shrink-0">↵</span>
    </button>
    </div>

    <!-- CONTACTOS -->
    <div *ngIf="(results?.contacts?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div class="px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide bg-gray-50 dark:bg-gray-800/50">
        Contactos · {{ results?.contacts?.length }}
      </div>
      <button *ngFor="let r of results?.contacts"
              (click)="onResultClick(r)"
              class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors">
        <svg class="w-4 h-4 flex-shrink-0" [class]="getIconClass('contact')" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
          <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>
      </button>
    </div>

    <!-- EMPRESAS -->
    <div *ngIf="(results?.companies?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div class="px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide bg-gray-50 dark:bg-gray-800/50">
        Empresas · {{ results?.companies?.length }}
      </div>
      <button *ngFor="let r of results?.companies"
              (click)="onResultClick(r)"
              class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors">
        <svg class="w-4 h-4 flex-shrink-0" [class]="getIconClass('company')" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19 21V5a2 2 0 00-2-2H7a2 2 0 00-2 2v16m14 0h2m-2 0h-5m-9 0H3m2 0h5M9 7h1m-1 4h1m4-4h1m-1 4h1m-5 10v-5a1 1 0 011-1h2a1 1 0 011 1v5m-4 0h4"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
          <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>
      </button>
    </div>

    <!-- NEGOCIOS -->
    <div *ngIf="(results?.deals?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div class="px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide bg-gray-50 dark:bg-gray-800/50">
        Negocios · {{ results?.deals?.length }}
      </div>
      <button *ngFor="let r of results?.deals"
              (click)="onResultClick(r)"
              class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors">
        <svg class="w-4 h-4 flex-shrink-0" [class]="getIconClass('deal')" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
          <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>
      </button>
    </div>

    <!-- TAREAS -->
    <div *ngIf="(results?.tasks?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div class="px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide bg-gray-50 dark:bg-gray-800/50">
        Tareas · {{ results?.tasks?.length }}
      </div>
      <button *ngFor="let r of results?.tasks"
              (click)="onResultClick(r)"
              class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors">
        <svg class="w-4 h-4 flex-shrink-0" [class]="getIconClass('task')" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
          <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>
      </button>
    </div>

    <!-- TICKETS — solo aparece si TICKETS_SEARCH_ENABLED y hay resultados -->
    <div *ngIf="(results?.tickets?.length ?? 0) > 0" class="border-b border-gray-100 dark:border-gray-800 last:border-0">
      <div class="px-3 py-2 text-xs font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide bg-gray-50 dark:bg-gray-800/50">
        Tickets · {{ results?.tickets?.length }}
      </div>
      <button *ngFor="let r of results?.tickets"
              (click)="onResultClick(r)"
              class="w-full flex items-center gap-3 px-3 py-2 hover:bg-gray-50 dark:hover:bg-gray-800 text-left transition-colors">
        <svg class="w-4 h-4 flex-shrink-0" [class]="getIconClass('ticket')" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" d="M15 5v2m0 4v2m0 4v2M5 5a2 2 0 00-2 2v3a2 2 0 110 4v3a2 2 0 002 2h14a2 2 0 002-2v-3a2 2 0 110-4V7a2 2 0 00-2-2H5z"/>
        </svg>
        <div class="flex-1 min-w-0">
          <p class="text-sm text-gray-800 dark:text-gray-200 m-0 truncate">{{ r.title }}</p>
          <p *ngIf="r.subtitle" class="text-xs text-gray-500 dark:text-gray-400 m-0 truncate">{{ r.subtitle }}</p>
        </div>
      </button>
    </div>

  </ng-container>
</div>